import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'components/common/Button';
import { AuthHero } from 'components/auth/AuthHero';
import { AuthService } from 'services/auth/auth.service';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      await AuthService.requestPasswordReset(email.trim());
      setSent(true);
    } catch (resetError: any) {
      setError(resetError?.message || 'Unable to send a password reset email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-start justify-start bg-[#f7f8f5] px-4 py-4 lg:items-center lg:justify-center lg:px-0 lg:py-0">
      <div className="grid w-full items-start gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(400px,0.85fr)] lg:items-center lg:gap-0">
        <AuthHero />
        <div className="w-full max-w-sm justify-self-center lg:mr-8">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-[#17231c]">Reset your password</h1>
          </div>
          <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
            {sent ? (
              <div className="space-y-3 text-center">
                <h2 className="text-lg font-semibold text-gray-900">Check your email</h2>
                <p className="text-sm text-gray-500">If an account exists for {email}, we sent a link to reset its password.</p>
                <Link to="/login" className="inline-block text-sm text-blue-600 hover:underline">Return to sign in</Link>
              </div>
            ) : (
              <>
                <p className="mb-5 text-sm text-gray-500">Enter your account email and we will send you a password reset link.</p>
                {error && <div className="mb-4 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div>}
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="mb-1 block text-sm font-medium text-gray-700">Email</label>
                    <input type="email" required value={email} onChange={event => setEmail(event.target.value)} className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                  </div>
                  <Button type="submit" loading={loading} className="w-full justify-center">Send reset link</Button>
                </form>
                <p className="mt-5 text-center text-xs text-gray-500"><Link to="/login" className="text-blue-600 hover:underline">Return to sign in</Link></p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
